/*******************************************************************************
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *
 *  *  Copyright © 2020 Pearson Education, Inc.
 *  *  All Rights Reserved.
 *  *
 *  * NOTICE:  All information contained herein is, and remains
 *  * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 *  * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 *  * patent applications, and are protected by trade secret or copyright law.
 *  * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 *  * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 ******************************************************************************/


const prod = {
  ENVIRONMENT: 'production',

  CLIENT_ID : 'BRSIcPHr2Iq0NV8AQP99zDZau8IPUxgy',

  API_KEY: 'v3BJEJFGC01g5lqDEiN03KuEvaiM5qKc',

  API_DOMAIN: 'https://api.pearson.com/gps/',

  ALS_DOMAIN: 'https://www.pearsonactivelearn.com/',

  IES_BASE_URL: 'https://login.pearson.com/v1/piapi',
  
  LAUNDING_URL: 'https://insights.pearson.com'

};

export default prod;